import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "col-md-12 d-flex align-items-center"
};
import { loadScript, unloadScript } from 'vue-plugin-load-script';
import Modal from '@/templates/argon-core/Modal.vue';
import { ref, toRefs, watchEffect, onMounted } from 'vue';
import AppgInput from '@/components/custom/AppgInput.vue';
import AppgBaseButton from '@/components/custom/AppgBaseButton.vue';
const postUrl = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
export default {
  __name: 'AppgKakaoPost',
  props: {
    _class: {
      type: String,
      default: 'col-md-12'
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      description: 'Whether input is required (adds an asterix *)'
    },
    valid: {
      type: Boolean,
      description: 'Whether is valid',
      default: true
    },
    inValidMessage: {
      type: String,
      description: 'Input error (below input)',
      default: '필수항목입니다.'
    },
    span: {
      type: String,
      description: 'small text',
      default: ''
    },
    address: {
      type: String,
      default: ''
    },
    detail: {
      type: String,
      default: ''
    }
  },
  emits: ['input'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const {
      valid,
      inValidMessage,
      address,
      detail
    } = toRefs(props);
    const modal = ref(false);
    const post = ref({
      address: '',
      detail: ''
    });
    const kakaoPost = ref();
    const load = async () => {
      await loadScript(postUrl);
      new daum.Postcode({
        onComplete: completeSearch,
        width: '100%',
        height: '100%'
      }).embed(kakaoPost.value);
    };
    const unload = () => {
      unloadScript(postUrl);
    };
    const toggle = () => {
      modal.value = !modal.value;
      if (modal.value) load();else unload();
    };
    const completeSearch = ({
      roadAddress
    }) => {
      post.value.address = roadAddress;
      toggle();
    };
    watchEffect(() => {
      if (!post.value.address && !post.value.detail) return;
      emits('input', {
        address: post.value.address,
        detail: post.value.detail
      });
    });
    watchEffect(() => {
      post.value.address = address.value;
      post.value.detail = detail.value;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(AppgInput, {
        _class: __props._class,
        label: __props.label,
        required: __props.required,
        span: __props.span,
        valid: _unref(valid),
        "in-valid-message": _unref(inValidMessage)
      }, {
        default: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(AppgInput, {
          disabled: true,
          _class: "col-md-8",
          placeholder: "주소를 검색해주세요.",
          modelValue: post.value.address,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => post.value.address = $event)
        }, null, 8, ["modelValue"]), _createVNode(AppgBaseButton, {
          label: "주소 검색",
          class: "ms-4 mb-3",
          onClick: toggle
        })]), _createVNode(AppgInput, {
          _class: "col-md-12",
          placeholder: "상세 주소를 입력해주세요.",
          modelValue: post.value.detail,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => post.value.detail = $event)
        }, null, 8, ["modelValue"]), _createVNode(Modal, {
          show: modal.value,
          "show-close": true,
          onClose: toggle
        }, {
          header: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("h6", null, "주소 검색", -1)])),
          default: _withCtx(() => [_createElementVNode("div", {
            class: "kakao-post",
            ref_key: "kakaoPost",
            ref: kakaoPost
          }, null, 512)]),
          _: 1
        }, 8, ["show"])]),
        _: 1
      }, 8, ["_class", "label", "required", "span", "valid", "in-valid-message"]);
    };
  }
};